import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "app-dialog card shadow-sm" }
const _hoisted_2 = { class: "card-header d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-0 app-dialog-message" }
const _hoisted_5 = { class: "card-footer d-flex justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.dialogState.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "app-dialog-backdrop",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.dialogState.title), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "aria-label": "Cerrar",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.dialogState.message), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.dialogState.mode === 'confirm')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline-secondary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
                }, _toDisplayString(_ctx.dialogState.cancelText), 1))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              ref: "confirmButton",
              type: "button",
              class: _normalizeClass(["btn", _ctx.confirmButtonClass]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onConfirm && _ctx.onConfirm(...args)))
            }, _toDisplayString(_ctx.dialogState.confirmText), 3)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}